module.exports = "/_next/static/images/empty-illus@2x_8203bd2ac5ad6127a9677db454793969.jpg";